<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">考核指标名称</div>
            <el-input v-model="edit_Name" placeholder="请输入考核指标名称" ></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">选择类型</div>
            <el-select v-model="edit_checkType" placeholder="请选择类型" style="width: 100%">
              <el-option
                  v-for="item in type_arr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-row>

      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm">提交</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Edit',
  props: [],
  data() {
    return {

      loading: false,

      edit_Name:'',

      checkNameId:'',

      edit_checkType:'',
      type_arr:[{value:'Common',label:'公共考核'},{value:'Special',label:'岗位考核'}],


    }
  },
  methods: {
    init(row){

      this.edit_Name = row.name;
      this.edit_checkType = row.checkType;
      this.checkNameId=row.id;

    },

    closeSelf() {
      this.loading= false
      this.$emit("closeEdit");
    },

    confirm(){

      if(this.edit_Name === ''){
        this.$message("输入名称");
        return;
      }
      if(this.edit_checkType === ''){
        this.$message("选择类型");
        return;
      }


      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'CheckName/AdmEdit',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          name: this.edit_Name,
          checkType:this.edit_checkType,
          checkNameId:this.checkNameId,
        }
      }).then( (response)=> {
        //console.log(response)
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeEdit");
          this.$emit("getList");
        }else{
          this.$message(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },


  }
}
</script>

